import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { withTheme } from 'styled-components'

// Components
import { Text, Tag } from '../../../Reusable/Text'
import TableView from '../../../Reusable/TableView'
import { Flex, FlexColumn, CardContainer } from '../../../Reusable/Container'
import styled from 'styled-components'
import { Descriptions, Skeleton, Collapse, Modal, Tooltip } from 'antd'
import { TextButton } from '../../../Reusable/Button'
import { Image } from '../../../Reusable/Image'
import { DownOutlined, UpOutlined, CheckCircleFilled, ExclamationCircleFilled, CloseCircleFilled } from '@ant-design/icons'

import environment from '../../../../environment'
import { ErrorAlert } from '../../../Reusable/Alert'
import { apiPOSTReq, getPreSignedS3Url } from '../../../../Utils/api'
import { toCurrency } from '../../../../Utils/util';
import Info from '../../../../Images/info.png'
import Download from "../../../../Images/download.png"
import PreScreenReview from './PreScreenReview'
import moment from 'moment'
import { saveAs } from 'file-saver'

export const DescItem = styled.div`
    display: flex;
    justify-content: flex-end;
`

export const DescLabel = styled.span`
    fontWeight: 500;
    fontSize: 16;
`

const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
})

class Index extends Component {
    state = {
        prescreenResultsLoaded: true,
        registrationLoaded: true,
        documentValidationExpandable: false,
        registrationSearchExpandable: false,
        kybVerificationExpandable: false,
        kycVerificationExpandable: false,
        creditLimitExpandable: false,
        kybMessage: '',
        kycMessage: '',
        viewDetails: false,
        pagination: {
            current: 1,
            pageSize: 10000
        },
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData = () => {
        const { loanApp } = this.props;
        var body = {
            "clientBusinessId": loanApp.businessId
        };
        console.log("/business/admin/getBusinessData body", body);
        this.setState({ prescreenResultsLoaded: false });
        apiPOSTReq(`${environment.uamBaseUrl}/business/admin/getBusinessData`, null, body, (err, resp) => {
            this.setState({ prescreenResultsLoaded: true });
            try {
                const data = resp || {};
                if (data.result) {
                    var owners = [];
                    owners.push(data.business.businessProfile.primaryApplicantInfo);
                    data.business.businessProfile.coOwnerApplicantInfo.forEach(owner => owners.push(owner));

                    this.setState({
                        business: data.business,
                        owners: owners
                    });

                    this.getRegistrationSearch();
                    this.getKnowYourBusiness();
                    this.getKnowYourCustomer();
                    this.fetchDebtSchedule();
                    this.getCashFlow();
                    this.getNegativeBankEvents();
                    this.fetchBusinessDocuments({ pagination: this.state.pagination })
                } else {
                    throw Error(data.responseMessage || data.error)
                }
            } catch (error) {
                //console.log("/getPersonCards err", error, resp);
                ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again." });
            }
        });
    }

    getRegistrationSearch = () => {
        const { loanApp } = this.props
        var body = {
            "clientBusinessId": loanApp.businessId,
            "applicationId": loanApp.applicationId,
            "rootType": 'RegistrationSearch'
        }

        console.log("/ops/loans/application/getVerificationResults body", body)
        this.setState({ registrationLoaded: false })
        apiPOSTReq(`${environment.opsBaseUrl}/ops/loans/application/getVerificationResults`, null, body, (err, resp) => {
            this.setState({ registrationLoaded: true })
            try {
                const data = resp || {}
                if (data.result) {
                    var businessValidations = data.businessValidations
                    this.setState({
                        registrationSearch: businessValidations
                    })
                    this.getLiens();
                } else {
                    throw Error(data.responseMessage || data.error)
                }
            } catch (error) {
                ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again." })
            }
        })
    }

    getLiens = () => {
        const { loanApp } = this.props
        var body = {
            "BusinessId": loanApp.businessId,
            "applicationId": loanApp.applicationId
        }

        console.log("/lsm/getLiens body", body)
        this.setState({ liensLoaded: false });
        apiPOSTReq(`${environment.lsmBaseUrl}/lsm/getLiens`, null, body, (err, resp) => {
            this.setState({ liensLoaded: true });
            try {
                const data = resp || {}
                if (data.result) {
                    var liens = data.liens
                    var stateLiens = data.stateLiens;
                    this.setState({
                        liens: liens,
                        stateLiens: stateLiens
                    })
                } else {
                    throw Error(data.responseMessage || data.error)
                }
            } catch (error) {
                ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again." })
            }
        })
    }

    getKnowYourBusiness = () => {
        const { loanApp } = this.props
        var body = {
            "clientBusinessId": loanApp.businessId,
            "applicationId": loanApp.applicationId,
            "rootType": 'KnowYourBusiness'
        }

        console.log("/ops/loans/application/getVerificationResults body", body)
        this.setState({ kybLoaded: false });
        apiPOSTReq(`${environment.opsBaseUrl}/ops/loans/application/getVerificationResults`, null, body, (err, resp) => {
            this.setState({ kybLoaded: true });
            try {
                const data = resp || {}
                if (data.result) {
                    var businessValidations = data.businessValidations
                    this.setState({
                        knowYourBusiness: businessValidations
                    })
                } else {
                    throw Error(data.responseMessage || data.error)
                }
            } catch (error) {
                ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again." })
            }
        })
    }

    getKnowYourCustomer = () => {
        const { loanApp } = this.props
        var body = {
            "clientBusinessId": loanApp.businessId,
            "applicationId": loanApp.applicationId,
            "rootType": 'KnowYourCustomer'
        }

        console.log("/ops/loans/application/getVerificationResults body", body)
        this.setState({ kycLoaded: false });
        apiPOSTReq(`${environment.opsBaseUrl}/ops/loans/application/getVerificationResults`, null, body, (err, resp) => {
            this.setState({ kycLoaded: true });
            try {
                const data = resp || {}
                if (data.result) {
                    var businessValidations = data.businessValidations
                    this.setState({
                        knowYourCustomer: businessValidations
                    })
                } else {
                    throw Error(data.responseMessage || data.error)
                }
            } catch (error) {
                ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again." })
            }
        })
    }

    fetchDebtSchedule = () => {
        const { loanApp } = this.props;
        var body = {
            applicationId: loanApp.applicationId,
            BusinessId: loanApp.businessId
        }
        apiPOSTReq(`${environment.uamBaseUrl}/uam/generateDebtSchedule`, {}, body, (err, resp) => {
            try {
                if (err) throw Error(err);
                const data = resp || {};
                if (data.result) {
                    if (data.debtOverview)
                        this.setState({ debtOverview: data.debtOverview })
                } else {
                    throw Error(data.responseMessage || data.error);
                }
            } catch (error) {
                console.log("/generateDebtSchedule err", error, resp);
            }
        });
    }

    getLiens = () => {
        const { loanApp } = this.props
        var body = {
            "BusinessId": loanApp.businessId,
            "applicationId": loanApp.applicationId
        }

        console.log("/lsm/getLiens body", body)
        this.setState({ liensLoaded: false });
        apiPOSTReq(`${environment.lsmBaseUrl}/lsm/getLiens`, null, body, (err, resp) => {
            this.setState({ liensLoaded: true });
            try {
                const data = resp || {}
                if (data.result) {
                    var liens = data.liens
                    var stateLiens = data.stateLiens;
                    this.setState({
                        liens: liens,
                        stateLiens: stateLiens
                    })
                } else {
                    throw Error(data.responseMessage || data.error)
                }
            } catch (error) {
                ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again." })
            }
        })
    }

    getCashFlow = () => {
        const { loanApp } = this.props
        var body = {
            "BusinessId": loanApp.businessId,
            "applicationId": loanApp.applicationId
        }

        console.log("/lsm/getLiens body", body)
        this.setState({ cshFlowLoaded: false });
        apiPOSTReq(`${environment.lsmBaseUrl}/lsm/getCashFlow`, null, body, (err, resp) => {
            this.setState({ cshFlowLoaded: true });
            try {
                const data = resp || {}
                if (data.result) {
                    this.setState({
                        cashFlow: data.indicators
                    })
                } else {
                    throw Error(data.responseMessage || data.error)
                }
            } catch (error) {
                ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again." })
            }
        })
    }

    getNegativeBankEvents = () => {
        const { loanApp } = this.props
        var body = {
            "BusinessId": loanApp.businessId,
            "applicationId": loanApp.applicationId
        }

        console.log("/lsm/getLiens body", body)
        this.setState({ cshFlowLoaded: false });
        apiPOSTReq(`${environment.lsmBaseUrl}/lsm/getNegativeBankEvents`, null, body, (err, resp) => {
            this.setState({ cshFlowLoaded: true });
            try {
                const data = resp || {}
                if (data.result) {
                    this.setState({
                        negativeBankEvents: data.indicators
                    })
                } else {
                    throw Error(data.responseMessage || data.error)
                }
            } catch (error) {
                ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again." })
            }
        })
    }

    fetchBusinessDocuments = (options) => {
        const { loanApp } = this.props;
        const { pagination } = options || {};
        var body = {
            "size": pagination.pageSize,
            "page": pagination.current - 1,
            "sortDirection": "DESC"
        };
        if (loanApp) {
            body["clientBusinessId"] = loanApp.businessId;
            body["applicationId"] = loanApp.applicationId;
            body["viewBy"] = "FILTER_APPLICATION_ID"
        }
        console.log("/docs/getActiveDocuments body", body);
        this.setState({ loading: true });
        apiPOSTReq(`${environment.uamBaseUrl}/docs/getActiveDocuments`, {}, body, (err, resp) => {
            console.log("/docs/getActiveDocuments resp", resp);
            this.setState({ loading: false });
            try {
                const data = resp || {};
                if (data.result) {

                    var businessDocuments = data.businessDocuments.filter(doc => doc.category != "Owner Financials");
                    this.setState({
                        businessDocuments: businessDocuments,
                        pagination: {
                            ...pagination,
                            total: data.count,
                            pageable: data.pageable
                        }
                    });

                } else {
                    throw Error(data.responseMessage || data.error)
                }
            } catch (error) {
                //console.log("/getPersonCards err", error, resp);
                ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again." });
            }
        });
    }

    downloadDoc = (item) => {
        const urlArr = item.documentUrl.uri.split('.');
        var fileExtension = urlArr[urlArr.length - 1];
        var filename = (item.name).includes(fileExtension) ? item.name : item.name == "FinancialReport" ? item.displayName + "." + fileExtension : item.name + "." + fileExtension;
        getPreSignedS3Url({ url: item.documentUrl.uri }, async (err, preSignedUrl) => {
            try {
                // prevents opening file in new tab
                let blob = await fetch(preSignedUrl).then((r) => r.blob());
                saveAs(blob, filename);

            } catch (err) {
                console.log(err);
            }
        })
    }

    handleClosePreScreenReview = () => {
        this.setState({ showPreScreenModal: false })
        this.props.updateStatus('')
    }

    preScreenReview = () => {
        this.setState({ showPreScreenModal: true });
    }

    getRegistrationSearchDisplay = () => {
        const { registrationSearch, registrationSearchExpandable, businessDocuments } = this.state;
        var { business } = this.state;
        var businessProfile = (business || {}).businessProfile || {};
        var businessInfo = businessProfile.businessInfo || {};
        var { name, physicalAddress } = businessInfo || {};
        var cnvDocs = [];
        var statusMessage = '';
        var showInfoIcon = false;
        var infoMessage = "";
        if (registrationSearch && registrationSearch.length > 0) {
            var message = registrationSearch[0].additionalParameterReference.parameters[0].value;
            if (message.includes('Error:')) {
                var splitMessage = message.split('Error: ')[1];
                statusMessage = splitMessage.split(':')[0];
                if (splitMessage.split(':').length > 1) {
                    showInfoIcon = true;
                    infoMessage = splitMessage.split(':')[1];
                }
            }
            else {
                statusMessage = 'Status: ' + message;
            }
        }

        if (businessDocuments && businessDocuments.length > 0) {
            cnvDocs = businessDocuments.filter(x => x.category && x.category.toLowerCase() === 'Know Your Business'.toLowerCase() && x.subCategory && x.subCategory.toLowerCase() === 'Business Registrations'.toLowerCase()
                && (x.auditData.createdBy === 'System' || !x.auditData.createdBy));
        }

        return (
            <Flex start fullWidth>
                <Descriptions
                    bordered
                    column={1}
                    style={{ width: '100%' }}
                >
                    <Descriptions.Item
                        label={(
                            <Flex start fullWidth>
                                <span>Registration Search</span>
                                {
                                    registrationSearch && registrationSearch.length > 0 && <><Tag primary>{statusMessage}</Tag>
                                        {
                                            showInfoIcon && <Tooltip overlayInnerStyle={{ width: 400, minWidth: 400 }}
                                                overlayStyle={{ width: 400, minWidth: 400 }} overlayClassName='roles-tooltip'
                                                placement="right" arrowPointAtCenter={false}
                                                title={<FlexColumn>
                                                    {
                                                        <Text color='white' size='14px' noWrap>{infoMessage}</Text>
                                                    }
                                                </FlexColumn>}>
                                                <div style={{ float: "right", width: 30 }}>
                                                    <Image src={Info} />
                                                </div>
                                            </Tooltip>
                                        }
                                    </>
                                }
                            </Flex>)
                        }
                        labelStyle={{ fontWeight: 500, fontSize: 16, width: '80%' }}
                        contentStyle={{ fontSize: 16 }}
                    >
                        <DescItem>
                            <div style={{ marginRight: 10 }}>
                                {
                                    registrationSearch ?
                                        (registrationSearch.length > 0 && registrationSearch[0].value == 'Approved' ? <CheckCircleFilled style={{ color: 'green' }} /> :
                                            registrationSearch.length > 0 && registrationSearch[0].value == 'Rejected' ? <CloseCircleFilled style={{ color: 'red' }} /> :
                                                <ExclamationCircleFilled style={{ color: 'orange' }} />)
                                        : <CloseCircleFilled style={{ color: 'red' }} />
                                }
                            </div>
                            {
                                <div
                                    style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                                    onClick={() => { this.setState({ registrationSearchExpandable: !registrationSearchExpandable }) }}
                                >
                                    {(registrationSearchExpandable === true ? <UpOutlined /> : <DownOutlined />)}
                                </div>
                            }
                        </DescItem>
                    </Descriptions.Item>
                    {
                        registrationSearchExpandable === true && <Descriptions.Item label={(
                            <div style={{ fontWeight: 500 }}>
                                Search Terms:  {`${name}, ` + (physicalAddress.line1 ? `${physicalAddress.line1} ${physicalAddress.line2 || ""}, ${physicalAddress.city || ""}, ${physicalAddress.countrySubDivisionCode || ""} ${physicalAddress.postalCode}` : "")}
                            </div>)} labelStyle={{ fontSize: 14, width: 400 }} contentStyle={{ fontSize: 14 }}>
                            <DescItem>
                            </DescItem>
                        </Descriptions.Item>
                    }
                    {
                        registrationSearchExpandable === true && cnvDocs.length > 0 && <>
                            <Descriptions.Item label={(
                                <Flex start fullWidth style={{ fontWeight: 500 }}>
                                    Registration Documents
                                </Flex>)} labelStyle={{ fontSize: 14, width: 400 }} contentStyle={{ fontSize: 14 }}>
                                <DescItem>
                                </DescItem>
                            </Descriptions.Item>
                            {
                                cnvDocs.map(
                                    x => <Descriptions.Item label={(
                                        <Flex start style={{ fontWeight: 500 }}>
                                            {(x.documentUrl || {}).uri && <TextButton onClick={(event) => { this.downloadDoc(x); }} rightIcon={<Image src={Download} />}text={x.name.substring(0, 25)} />}
                                        </Flex>)} labelStyle={{ fontSize: 14, width: 400 }} contentStyle={{ fontSize: 14 }}>
                                        <DescItem>
                                        </DescItem>
                                    </Descriptions.Item>
                                )
                            }
                        </>
                    }
                </Descriptions>
            </Flex>
        )
    }

    createLiens = (liens) => {
        var items = [];
        (liens || []).forEach(item => {
            var securedParties = item.name.split(';')[0].trim().replace(/,\s*$/, "");
            var status = item.name.split(';')[1].trim();

            var exipirationDate = moment(item.name.split(';')[2].trim(), 'MM-DD-YYYY').format('MMM DD, YYYY')
            var debtors = item.value.split(';')[0].trim().replace(/,\s*$/, "");
            var filingNum = item.value.split(';')[1].trim().replace(/,\s*$/, "");
            var filingDate = moment(item.value.split(';')[2].trim(), 'MM-DD-YYYY').format('MMM DD, YYYY')
            items.push(
                <Descriptions.Item label={(
                    <div style={{ paddingLeft: 25 }}>
                        <div style={{ marginBottom: 10 }}>
                            <span style={{ fontWeight: 500 }}>{"Filing Number: ".toUpperCase()}</span> {filingNum.toUpperCase()}
                        </div>
                        <div style={{ marginBottom: 10 }}>
                            <span style={{ fontWeight: 500 }}>{"Filing Date: ".toUpperCase()}</span> {filingDate.toUpperCase()}
                        </div>
                        <div style={{ marginBottom: 10 }}>
                            <span style={{ fontWeight: 500 }}>{"Expiration Date: ".toUpperCase()}</span> {exipirationDate.toUpperCase()}
                        </div>
                        <div style={{ marginBottom: 10 }}>
                            <span style={{ fontWeight: 500 }}>{"Secured Parties: ".toUpperCase()}</span> {securedParties.toUpperCase()}
                        </div>
                        <div>
                            <span style={{ fontWeight: 500 }}>{"Debtors: ".toUpperCase()}</span> {debtors.toUpperCase()}
                        </div>
                    </div>)}
                    labelStyle={{ fontSize: 14, width: 400 }} contentStyle={{ fontSize: 14 }}>
                    <DescItem>
                        {
                            status.toUpperCase()
                        }
                    </DescItem>
                </Descriptions.Item>
            )
        });
        return items;
    }

    createLiensOld = () => {
        const { liens } = this.state;
        var items = [];
        (liens || []).forEach(item => {
            var securedParties = item.name.split(';')[0].trim().replace(/,\s*$/, "");
            var status = item.name.split(';')[1];
            var debtors = item.value.replace(/,\s*$/, "");
            items.push(
                <Descriptions.Item label={(
                    <div style={{ paddingLeft: 25 }}>
                        <div style={{ marginBottom: 10 }}>
                            <span style={{ fontWeight: 500 }}>{"Secured Parties: ".toUpperCase()}</span> {securedParties.toUpperCase()}
                        </div>
                        <div>
                            <span style={{ fontWeight: 500 }}>{"Debtors: ".toUpperCase()}</span> {debtors.toUpperCase()}
                        </div>
                    </div>)}
                    labelStyle={{ fontSize: 14, width: 400 }} contentStyle={{ fontSize: 14 }}>
                    <DescItem>
                        {
                            status.toUpperCase()
                        }
                    </DescItem>
                </Descriptions.Item>
            )
        });
        return items;
    }

    getLiensDisplay = () => {
        const { stateLiens, liens, liensExpandable } = this.state
        var { business } = this.state;
        var businessProfile = (business || {}).businessProfile || {};
        var businessInfo = businessProfile.businessInfo || {};
        var { name } = businessInfo || {};

        return (
            <Flex start fullWidth style={{ marginTop: 10 }}>
                <Descriptions
                    bordered
                    column={1}
                    style={{ width: '100%' }}
                >
                    <Descriptions.Item
                        label={(<Flex start fullWidth><span>UCC Lien Search</span></Flex>)}
                        labelStyle={{ fontWeight: 500, fontSize: 16, width: '80%' }}
                        contentStyle={{ fontSize: 16 }}
                    >
                        <DescItem>
                            <div style={{ marginRight: 10 }}>
                                {
                                    liens ?
                                        (liens.length < 2 ? <CheckCircleFilled style={{ color: 'green' }} /> :
                                            liens.length >= 2 ? <CloseCircleFilled style={{ color: 'red' }} /> :
                                                <ExclamationCircleFilled style={{ color: 'orange' }} />)
                                        : <CloseCircleFilled style={{ color: 'red' }} />
                                }
                            </div>
                            {
                                <div
                                    style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                                    onClick={() => { this.setState({ liensExpandable: !liensExpandable }) }}
                                >
                                    {(liensExpandable === true ? <UpOutlined /> : <DownOutlined />)}
                                </div>
                            }
                        </DescItem>
                    </Descriptions.Item>
                    {
                        liensExpandable === true && stateLiens &&
                        Object.keys(stateLiens).map(x =>
                            <>
                                <Descriptions.Item label={(
                                    <Flex start fullWidth style={{ fontWeight: 500 }}>
                                        Search Terms: {`${name}, ` + x}
                                    </Flex>)} labelStyle={{ fontSize: 14, width: 400 }} contentStyle={{ fontSize: 14 }}>
                                    <DescItem>
                                    </DescItem>
                                </Descriptions.Item>
                                <Descriptions.Item label={(
                                    <div style={{ fontWeight: 500 }}>
                                        Lien Information
                                    </div>)}
                                    labelStyle={{ fontSize: 14, width: 400 }} contentStyle={{ fontSize: 14 }}>
                                    <DescItem>
                                        <div style={{ fontWeight: 500 }}>
                                            Status
                                        </div>
                                    </DescItem>
                                </Descriptions.Item>
                                {
                                    this.createLiens(stateLiens[x])
                                }
                            </>
                        )
                    }
                    {
                        liensExpandable === true && !stateLiens && liens && liens.length > 0 && <Descriptions.Item label={(
                            <div style={{ fontWeight: 500 }}>
                                Lien Information
                            </div>)}
                            labelStyle={{ fontSize: 14, width: 400 }} contentStyle={{ fontSize: 14 }}>
                            <DescItem>
                                <div style={{ fontWeight: 500 }}>
                                    Status
                                </div>
                            </DescItem>
                        </Descriptions.Item>
                    }
                    {
                        liensExpandable === true && !stateLiens && liens && this.createLiensOld()
                    }
                </Descriptions>
            </Flex>
        )

    }

    getKybDisplay = () => {
        const { knowYourBusiness, kybVerificationExpandable, businessDocuments } = this.state;
        var { business } = this.state;
        var businessProfile = (business || {}).businessProfile || {};
        var businessInfo = businessProfile.businessInfo || {};
        var { name, physicalAddress, mailingAddress } = businessInfo || {};
        var kybMessage = (knowYourBusiness || []).length > 0 ?
            knowYourBusiness[1].name == "PrevIdConfirmScore" ? 'Business could not be found in CLEAR for Registration Address, it ran for Mailing Address.' : '' : ''

        var registeredIdConfirmDocs = [];
        var mailingIdConfirmDocs = [];
        var riskInformDocs = [];
        if (businessDocuments && businessDocuments.length > 0) {
            registeredIdConfirmDocs = businessDocuments.filter(x => x.category && x.category.toLowerCase() === 'Know Your Business'.toLowerCase() && x.subCategory && x.subCategory.toLowerCase() === 'ID Confirm Reports'.toLowerCase()
                && x.name.toLowerCase().includes('Registered_Address_Search'.toLowerCase())
                && (x.auditData.createdBy === 'System' || !x.auditData.createdBy));

            mailingIdConfirmDocs = businessDocuments.filter(x => x.category && x.category.toLowerCase() === 'Know Your Business'.toLowerCase() && x.subCategory && x.subCategory.toLowerCase() === 'ID Confirm Reports'.toLowerCase()
                && x.name.toLowerCase().includes('Mailing_Address_Search'.toLowerCase())
                && (x.auditData.createdBy === 'System' || !x.auditData.createdBy));

            riskInformDocs = businessDocuments.filter(x => x.category && x.category.toLowerCase() === 'Know Your Business'.toLowerCase() && x.subCategory && x.subCategory.toLowerCase() === 'Clear/TR Reports'.toLowerCase()
                && (x.auditData.createdBy === 'System' || !x.auditData.createdBy));
        }

        return (
            <Flex start fullWidth style={{ marginTop: 10 }}>
                <Descriptions
                    bordered
                    column={1}
                    style={{ width: '100%' }}
                >
                    <Descriptions.Item
                        label={(<div style={{ display: "flex" }}><span>KYB Verification</span>
                            {
                                kybMessage != '' && <Tag primary>{kybMessage}</Tag>
                            }
                        </div>)}
                        labelStyle={{ fontWeight: 500, fontSize: 16, width: '80%' }}
                        contentStyle={{ fontSize: 16 }}
                    >
                        <DescItem>
                            <div style={{ marginRight: 10 }}>
                                {
                                    knowYourBusiness ?
                                        (knowYourBusiness.length > 0 && knowYourBusiness[0].value == 'Approved' ? <CheckCircleFilled style={{ color: 'green' }} /> :
                                            knowYourBusiness.length > 0 && knowYourBusiness[0].value == 'Rejected' ? <CloseCircleFilled style={{ color: 'red' }} />
                                                : <ExclamationCircleFilled style={{ color: 'orange' }} />)
                                        : <CloseCircleFilled style={{ color: 'red' }} />
                                }
                            </div>
                            <div
                                style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                                onClick={() => { this.setState({ kybVerificationExpandable: !kybVerificationExpandable }) }}
                            >
                                {(kybVerificationExpandable === true ? <UpOutlined /> : <DownOutlined />)}
                            </div>
                        </DescItem>
                    </Descriptions.Item>
                    {
                        kybVerificationExpandable === true &&
                        <>
                            {
                                kybMessage != '' &&
                                <>
                                    <Descriptions.Item label={(
                                        <div style={{ fontWeight: 500 }}>
                                            Search Terms: {
                                                `${name}, ` +
                                                (kybMessage != '' && physicalAddress.line1 ? `${physicalAddress.line1} ${physicalAddress.line2 || ""}, ${physicalAddress.city || ""}, ${physicalAddress.countrySubDivisionCode || ""} ${physicalAddress.postalCode}` : "")}
                                        </div>)} labelStyle={{ fontSize: 14, width: 400 }} contentStyle={{ fontSize: 14 }}>
                                        <DescItem>
                                        </DescItem>
                                    </Descriptions.Item>
                                    {(knowYourBusiness || []).map(item => {
                                        if (item.rank != 0 && item.name === "PrevIdConfirmScore") {
                                            return (<Descriptions.Item label={(
                                                <Flex start fullWidth style={{ paddingLeft: item.parentType !== "KnowYourBusiness" ? 35 : 25 }}>
                                                    <FlexColumn start style={{ width: '95%' }}>
                                                        <Flex start fullWidth>
                                                            {`${item.displayName} (Score: ${item.additionalParameterReference.parameters[0].value})`}
                                                            {
                                                                (item.name === "PrevIdConfirmScore") &&
                                                                <Tooltip overlayInnerStyle={{ width: 400, minWidth: 400 }} overlayStyle={{ width: 400, minWidth: 400 }} overlayClassName='roles-tooltip' placement="right" arrowPointAtCenter={false} title={<FlexColumn>
                                                                    {
                                                                        item.additionalParameterReference.parameters.map(item => (
                                                                            <Text color='white' size='14px' noWrap>{`${item.name} - ${item.value}`}</Text>
                                                                        ))
                                                                    }
                                                                </FlexColumn>}>
                                                                    <div style={{ float: "right", width: 30 }}>
                                                                        <Image src={Info} />
                                                                    </div>
                                                                </Tooltip>
                                                            }
                                                        </Flex>
                                                    </FlexColumn>
                                                    <FlexColumn style={{ width: '5%' }} end>
                                                        {
                                                            registeredIdConfirmDocs.map(x => <TextButton margin='0 5px' onClick={() => { this.downloadDoc(x) }} rightIcon={<Image src={Download} />} />)
                                                        }
                                                    </FlexColumn>
                                                </Flex>)}>
                                                <DescItem>
                                                    {
                                                        item.value == 'Approved' ? <CheckCircleFilled style={{ color: 'green' }} /> :
                                                            item.value == 'Review' ? <ExclamationCircleFilled style={{ color: 'orange' }} /> :
                                                                item.value == 'ProcessingError' ? '--'
                                                                    : <CloseCircleFilled style={{ color: 'red' }} />
                                                    }
                                                </DescItem>
                                            </Descriptions.Item>)
                                        }
                                        else {
                                            return (<></>)
                                        }
                                    })}
                                </>
                            }
                            <Descriptions.Item label={(
                                <div style={{ fontWeight: 500 }}>
                                    Search Terms: {
                                        `${name}, ` +
                                        (kybMessage != '' ?
                                            mailingAddress.line1 ? `${mailingAddress.line1} ${mailingAddress.line2 || ""}, ${mailingAddress.city || ""}, ${mailingAddress.countrySubDivisionCode || ""} ${mailingAddress.postalCode}` : ""
                                            : physicalAddress.line1 ? `${physicalAddress.line1} ${physicalAddress.line2 || ""}, ${physicalAddress.city || ""}, ${physicalAddress.countrySubDivisionCode || ""} ${physicalAddress.postalCode}` : "")}
                                </div>)} labelStyle={{ fontSize: 14, width: 400 }} contentStyle={{ fontSize: 14 }}>
                                <DescItem>
                                </DescItem>
                            </Descriptions.Item>
                            {
                                (knowYourBusiness || []).map(item => {
                                    if (item.rank != 0 && item.name !== "PrevIdConfirmScore") {
                                        var additionalParameterReference = item.additionalParameterReference || {};
                                        var parameters = additionalParameterReference.parameters;
                                        var params = [];
                                        if (item.name === "ListOfPrincipalsExecutivesTiedToBusiness" && parameters) {
                                            params = parameters;
                                        }
                                        return (<Descriptions.Item label={(
                                            <Flex start fullWidth style={{ paddingLeft: item.parentType !== "KnowYourBusiness" ? 35 : 25 }}>
                                                <FlexColumn start style={{ width: '95%' }}>
                                                    <Flex start fullWidth>
                                                        {`${item.displayName} ${(item.name === "PrevIdConfirmScore" || item.name === "IdConfirmScore" || item.name === "RiskInformScore") ? " (Score: " + item.additionalParameterReference.parameters[0].value + ")" : ""}`}
                                                        {
                                                            (item.name === "PrevIdConfirmScore" || item.name === "IdConfirmScore" || item.name === "RiskInformScore") &&
                                                            <Tooltip overlayInnerStyle={{ width: 400, minWidth: 400 }} overlayStyle={{ width: 400, minWidth: 400 }} overlayClassName='roles-tooltip' placement="right" arrowPointAtCenter={false} title={<FlexColumn>
                                                                {
                                                                    item.additionalParameterReference.parameters.map(item => (
                                                                        <Text color='white' size='14px' noWrap>{`${item.name} - ${item.value}`}</Text>
                                                                    ))
                                                                }
                                                            </FlexColumn>}>
                                                                <div style={{ float: "right", width: 30 }}>
                                                                    <Image src={Info} />
                                                                </div>
                                                            </Tooltip>
                                                        }
                                                        {
                                                            (item.name === "ListOfPrincipalsExecutivesTiedToBusiness") && params.length > 0 &&
                                                            <Tooltip overlayInnerStyle={{ width: 400, minWidth: 400 }} overlayStyle={{ width: 400, minWidth: 400 }} overlayClassName='roles-tooltip' placement="right" arrowPointAtCenter={false}
                                                                title={<FlexColumn>
                                                                    {
                                                                        params.map(item => (
                                                                            <>
                                                                                <Text color='white' size='14px' noWrap>{`Name: ${item.name}`}</Text>
                                                                                <Text color='white' size='14px' noWrap style={{ marginBottom: 10 }}>{`Title: ${item.value}`}</Text>
                                                                            </>
                                                                        ))
                                                                    }
                                                                </FlexColumn>}>
                                                                <div style={{ float: "right", width: 30 }}>
                                                                    <Image src={Info} />
                                                                </div>
                                                            </Tooltip>
                                                        }
                                                    </Flex>
                                                </FlexColumn>
                                                <FlexColumn style={{ width: '5%' }} end>
                                                    {
                                                        (item.name === "IdConfirmScore") && (kybMessage != '' ? mailingIdConfirmDocs.map(x => <TextButton margin='0 5px' onClick={() => { this.downloadDoc(x) }} rightIcon={<Image src={Download} />} />) :
                                                            registeredIdConfirmDocs.map(x => <TextButton margin='0 5px' onClick={() => { this.downloadDoc(x) }} rightIcon={<Image src={Download} />} />))
                                                    }
                                                    {
                                                        item.name === "RiskInformScore" && riskInformDocs.map(x => <TextButton margin='0 5px' onClick={() => { this.downloadDoc(x) }} rightIcon={<Image src={Download} />} />)
                                                    }
                                                </FlexColumn>
                                            </Flex>)}>
                                            <DescItem>
                                                {
                                                    item.value == 'Approved' ? <CheckCircleFilled style={{ color: 'green' }} /> :
                                                        item.value == 'Review' ? <ExclamationCircleFilled style={{ color: 'orange' }} /> :
                                                            item.value == 'ProcessingError' ? '--'
                                                                : <CloseCircleFilled style={{ color: 'red' }} />
                                                }
                                            </DescItem>
                                        </Descriptions.Item>)
                                    }
                                    else {
                                        return (<></>)
                                    }
                                })
                            }
                        </>
                    }
                </Descriptions>
            </Flex>);
    }

    getKycDisplay = () => {
        var { kycMessage, knowYourCustomer, kycVerificationExpandable, owners, businessDocuments } = this.state;
        owners = owners || [];

        var idConfirmDocs = [];
        var riskInformDocs = [];
        if (businessDocuments && businessDocuments.length > 0) {
            idConfirmDocs = businessDocuments.filter(x => x.category && x.category.toLowerCase() === 'Know Your Customer'.toLowerCase() && x.subCategory && x.subCategory.toLowerCase() === 'ID Confirm Reports'.toLowerCase()
                && (x.auditData.createdBy === 'System' || !x.auditData.createdBy));
        }

        if (businessDocuments && businessDocuments.length > 0) {
            riskInformDocs = businessDocuments.filter(x => x.category && x.category.toLowerCase() === 'Know Your Customer'.toLowerCase() && x.subCategory && x.subCategory.toLowerCase() === 'Clear/TR Reports'.toLowerCase()
                && (x.auditData.createdBy === 'System' || !x.auditData.createdBy));
        }

        return (
            <Flex start fullWidth style={{ marginTop: 10 }}>
                <Descriptions
                    bordered
                    column={1}
                    style={{ width: '100%' }}
                >
                    <Descriptions.Item
                        label={(<div style={{ display: "flex" }}><span>KYC Verification</span>
                            {
                                kycMessage != '' && <Tag primary>{kycMessage}</Tag>
                            }
                        </div>)}
                        labelStyle={{ fontWeight: 500, fontSize: 16, width: '80%' }}
                        contentStyle={{ fontSize: 16 }}
                    >
                        <DescItem>
                            <div style={{ marginRight: 10 }}>
                                {
                                    knowYourCustomer ?
                                        (knowYourCustomer.length > 0 && knowYourCustomer[0].value == 'Approved' ? <CheckCircleFilled style={{ color: 'green' }} /> :
                                            knowYourCustomer.length > 0 && knowYourCustomer[0].value == 'Rejected' ? <CloseCircleFilled style={{ color: 'red' }} />
                                                : <ExclamationCircleFilled style={{ color: 'orange' }} />)
                                        : <CloseCircleFilled style={{ color: 'red' }} />
                                }
                            </div>
                            <div
                                style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                                onClick={() => { this.setState({ kycVerificationExpandable: !kycVerificationExpandable }) }}
                            >
                                {(kycVerificationExpandable === true ? <UpOutlined /> : <DownOutlined />)}
                            </div>
                        </DescItem>
                    </Descriptions.Item>
                    {
                        kycVerificationExpandable === true &&
                        (knowYourCustomer || []).map(item => {
                            if (item.rank != 0) {
                                if (item.type == 'KnowYourCustomerPerson') {
                                    var owner = {};
                                    owners.forEach(o => {
                                        if (o.firstName.toLowerCase() + " " + o.lastName.toLowerCase() === item.displayName.toLowerCase()) {
                                            owner = o;
                                        }
                                    })

                                    return (
                                        <>
                                            <Descriptions.Item label={
                                                <div style={{ fontWeight: 500, paddingLeft: 25 }}>{item.displayName}</div>}
                                                labelStyle={{ fontSize: 15, width: 400 }} contentStyle={{ fontSize: 14 }}>
                                                <DescItem>
                                                    {
                                                        item.value == 'Approved' ? <CheckCircleFilled style={{ color: 'green' }} /> :
                                                            item.value == 'Review' || item.value == 'ProcessingError' ? <ExclamationCircleFilled style={{ color: 'orange' }} />
                                                                : <CloseCircleFilled style={{ color: 'red' }} />
                                                    }
                                                </DescItem>
                                            </Descriptions.Item>
                                            <Descriptions.Item label={(
                                                <div style={{ fontWeight: 500, paddingLeft: 25 }}>
                                                    Search Terms:  {`${item.displayName}, ` + (owner.address.line1 ? `${owner.address.line1} ${owner.address.line2 || ""}, ${owner.address.city || ""}, ${owner.address.countrySubDivisionCode || ""} ${owner.address.postalCode}` : "")}
                                                </div>)} labelStyle={{ fontSize: 14, width: 400 }} contentStyle={{ fontSize: 14 }}>
                                                <DescItem>
                                                </DescItem>
                                            </Descriptions.Item>
                                            {
                                                (knowYourCustomer || []).map(subItem => {
                                                    if (subItem.type == 'KnowYourCustomerItem' && subItem.parentName == item.name) {
                                                        var additionalParameterReference = subItem.additionalParameterReference || {};
                                                        var parameters = additionalParameterReference.parameters;
                                                        var params = [];
                                                        if (subItem.name == 'CriminalHistory' && parameters) {
                                                            params = parameters.filter(x => x.value != 'Approved')
                                                        }

                                                        return (<Descriptions.Item label={(
                                                            <Flex start fullWidth style={{ paddingLeft: subItem.parentType !== "KnowYourCustomerPerson" ? 45 : 35 }}>
                                                                <FlexColumn start style={{ width: '95%' }}>
                                                                    <Flex start fullWidth>
                                                                        {`${subItem.displayName} ${(subItem.name === "IdConfirmScore" || subItem.name === "RiskInformScore") ? " (Score: " + subItem.additionalParameterReference.parameters[0].value + ")" : ""}`}
                                                                        {
                                                                            (subItem.name === "IdConfirmScore" || subItem.name === "RiskInformScore") &&
                                                                            <Tooltip overlayInnerStyle={{ width: 400, minWidth: 400 }} overlayStyle={{ width: 400, minWidth: 400 }} overlayClassName='roles-tooltip' placement="right" arrowPointAtCenter={false} title={<FlexColumn>
                                                                                {
                                                                                    subItem.additionalParameterReference.parameters.map(p => (
                                                                                        <Text color='white' size='14px' noWrap>{`${p.name} - ${p.value}`}</Text>
                                                                                    ))
                                                                                }
                                                                            </FlexColumn>}>
                                                                                <div style={{ float: "right", width: 30 }}>
                                                                                    <Image src={Info} />
                                                                                </div>
                                                                            </Tooltip>
                                                                        }
                                                                        {
                                                                            (subItem.name == 'CriminalHistory' && (subItem.value != 'Approved' && subItem.value != 'ProcessingError')) && <Tooltip overlayInnerStyle={{ width: 400, minWidth: 400 }} overlayStyle={{ width: 400, minWidth: 400 }} overlayClassName='roles-tooltip' placement="right" arrowPointAtCenter={false} title={<FlexColumn>
                                                                                {
                                                                                    params.map(item => (
                                                                                        <Text color='white' size='14px' noWrap>{`${item.name} - ${item.value}`}</Text>
                                                                                    ))
                                                                                }
                                                                            </FlexColumn>}>
                                                                                <div style={{ float: "right", width: 30 }}>
                                                                                    <Image src={Info} />
                                                                                </div>
                                                                            </Tooltip>
                                                                        }

                                                                    </Flex>
                                                                </FlexColumn>
                                                                <FlexColumn style={{ width: '5%' }} end>
                                                                    {
                                                                        subItem.name === "IdConfirmScore" && idConfirmDocs.map(x => x.name.toLowerCase().includes(item.displayName.toLowerCase().replace(' ', '_')) && <TextButton margin='0 5px' onClick={() => { this.downloadDoc(x) }} rightIcon={<Image src={Download} />} />)
                                                                    }
                                                                    {
                                                                        subItem.name === "RiskInformScore" && riskInformDocs.map(x => x.name.toLowerCase().includes(item.displayName.toLowerCase().replace(' ', '_')) && <TextButton margin='0 5px' onClick={() => { this.downloadDoc(x) }} rightIcon={<Image src={Download} />} />)
                                                                    }
                                                                </FlexColumn>
                                                            </Flex>)} labelStyle={{ fontSize: 14, width: 400 }} contentStyle={{ fontSize: 14 }}>
                                                            <DescItem>
                                                                {
                                                                    subItem.value == 'Approved' ? <CheckCircleFilled style={{ color: 'green' }} /> :
                                                                        subItem.value == 'Review' ? <ExclamationCircleFilled style={{ color: 'orange' }} /> :
                                                                            subItem.value == 'ProcessingError' ? '--'
                                                                                : <CloseCircleFilled style={{ color: 'red' }} />
                                                                }
                                                            </DescItem>
                                                        </Descriptions.Item>)
                                                    }
                                                    else {
                                                        return (<></>)
                                                    }
                                                })
                                            }
                                        </>
                                    )
                                }
                                else {
                                    return (<></>)
                                }
                            }
                            else {
                                return (<></>)
                            }
                        })
                    }
                </Descriptions>
            </Flex>
        )
    }

    getPreScreenResult = () => {
        const { loanApp } = this.props;
        const { showPreScreenModal } = this.state;
        return (
            <FlexColumn between>
                <FlexColumn>
                    <Flex fullWidth>
                        <FlexColumn style={{ width: '49%' }}>
                            <Text heading>Pre-Screen Results</Text>
                        </FlexColumn>
                        <FlexColumn right style={{ width: '49%' }}>
                            <TextButton onClick={this.preScreenReview} text="Review" />
                        </FlexColumn>
                    </Flex>
                    {
                        this.getRegistrationSearchDisplay()
                    }
                    {
                        this.getLiensDisplay()
                    }
                    {
                        this.getKybDisplay()
                    }
                    {
                        this.getKycDisplay()
                    }
                    <Modal
                        visible={showPreScreenModal}
                        footer={null}
                        closable={true}
                        width={600}
                        style={{ top: 10 }}
                        destroyOnClose={true}
                        onCancel={() => {
                            this.setState({ showPreScreenModal: false })
                        }}
                    >
                        <PreScreenReview loanApp={loanApp} handleClosePreScreenReview={this.handleClosePreScreenReview}></PreScreenReview>
                    </Modal >
                </FlexColumn>
            </FlexColumn>
        )
    }

    getDebtColumns = () => {
        return [
            {
                title: 'Creditor Name',
                dataIndex: 'name',
                width: '20%'
            },
            {
                title: 'Monthly Debt Payment',
                dataIndex: 'outstandingDebt',
                key: 'outstandingDebt',
                render: (item) => '$' + toCurrency(item),
                width: '20%'
            },
            {
                title: 'Total Outstanding Balance',
                dataIndex: 'totalOutstandingDebt',
                key: 'totalOutstandingDebt',
                render: (item) => '$' + toCurrency(item),
                width: '20%'
            },
            {
                title: 'Collateral Type',
                width: '20%',
                dataIndex: 'collateralType'
            },
            {
                title: 'Source',
                width: '20%',
                dataIndex: 'source',
                render: (item) => item == "System" ? "Ilien" : "Manual",
            }]
    }
    getRiskIndicatorsColumn = () => {
        return [
            {
                title: 'Name',
                dataIndex: 'displayType',
                width: '50%'
            },
            {
                title: 'Result',
                width: '50%',
                render: (item) => <Flex start>{item.indicator}
                    <Tooltip overlayInnerStyle={{ width: 400, minWidth: 400 }} overlayStyle={{ width: 400, minWidth: 400 }} overlayClassName='roles-tooltip' placement="right" arrowPointAtCenter={false} title={<FlexColumn>
                        <Text color='white' size='14px'>{`${item.analysis}`}</Text>
                    </FlexColumn>}>
                        <div style={{ float: "right", width: 30 }}>
                            <Image src={Info} />
                        </div>
                    </Tooltip>
                </Flex>
            }]
    }

    getConnectionSummary = () => {
        const { debtOverview, cashFlow, negativeBankEvents } = this.state;
        const { loanApp } = this.props;
        var parameters = loanApp.additionalParameters || [];
        var eligibleCollateral = parameters.length > 0 ? parameters[0].value : 0;
        return (
            <FlexColumn between>
                <FlexColumn>
                    <Flex start fullWidth>
                        <Text heading>Connection Summary</Text>
                    </Flex>
                    <Collapse bordered={true} defaultActiveKey={"eligibleCollateral"} style={{ width: "100%" }}>
                        <Collapse.Panel header="Eligible Collateral" key="eligibleCollateral">
                            <Flex start fullWidth style={{ marginTop: 10 }}>
                                Eligible Collateral: {formatter.format(eligibleCollateral)}
                            </Flex>
                        </Collapse.Panel>
                        <Collapse.Panel header="Debt Schedule" key="debtSchedule">
                            <Flex start fullWidth style={{ marginTop: 10 }}>
                                <TableView
                                    id="debt-table"
                                    tableLayout='auto'
                                    columns={this.getDebtColumns()}
                                    dataSource={debtOverview}
                                    rowKey='id' />
                            </Flex>
                        </Collapse.Panel>
                        <Collapse.Panel header="Cashflow Risk Indicators" key="cashflowRiskIndicators">
                            <Flex start fullWidth style={{ marginTop: 10 }}>
                                <TableView
                                    id="debt-table"
                                    tableLayout='auto'
                                    columns={this.getRiskIndicatorsColumn()}
                                    dataSource={cashFlow}
                                    rowKey='id' />
                            </Flex>
                        </Collapse.Panel>
                        <Collapse.Panel header="Negative Bank events" key="negativeBankevents">
                            <Flex start fullWidth style={{ marginTop: 10 }}>
                                <TableView
                                    id="debt-table"
                                    tableLayout='auto'
                                    columns={this.getRiskIndicatorsColumn()}
                                    dataSource={negativeBankEvents}
                                    rowKey='id' />
                            </Flex>
                        </Collapse.Panel>
                    </Collapse>
                </FlexColumn>
            </FlexColumn>
        )
    }

    render() {
        const { prescreenResultsLoaded, registrationLoaded, liensLoaded, kybLoaded, kycLoaded } = this.state;
        return (
            <CardContainer fullWidth>
                <Flex between fullHeight>
                    <Skeleton loading={!prescreenResultsLoaded || !registrationLoaded || !liensLoaded || !kybLoaded || !kycLoaded} active title={false} paragraph={{ rows: 9 }}>
                        <FlexColumn fullHeight style={{ marginTop: "20px", width: '49%' }}>
                            {
                                this.getPreScreenResult()
                            }
                        </FlexColumn>
                        <FlexColumn fullHeight style={{ marginTop: "20px", width: '49%' }}>
                            {
                                this.getConnectionSummary()
                            }
                        </FlexColumn>
                    </Skeleton>
                </Flex>
            </CardContainer>
        )
    }
}
function mapStateToProps(state) {
    return {
        store: state.aionAppReducer
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(Index)))